export const monthNames = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

export const dateFormat = (date = null) => {
  let currentDate = new Date(date);
  if (!date) {
    currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
  }
  let currentMonth = currentDate.getMonth() + 1;
  let currentDay = currentDate.getDate();
  if (currentDay < 10) currentDay = "0" + currentDay;
  if (currentMonth < 10) {
    currentMonth = "0" + currentMonth;
  }
  return currentDate.getFullYear() + "-" + currentMonth + "-" + currentDay;
} 